import React, { Component } from 'react';
import styled from 'styled-components';
import Dropzone from 'react-dropzone';
import { rem } from 'polished';
import PropTypes from 'prop-types';
import { Textarea, Button } from 'oxyrion-ui/lib';
import Img from 'react-image';
import { formatDate, FORMAT_HUMANE_DATETIME, __ } from '../../Utils';
import FileViewDownload from '../FileViewDownload';

const StyledTextarea = styled(Textarea)`
  width: 90%;
`;

const Wrapper = styled.div`
  outline: none;
  color: ${({ sorter, theme }) => sorter && theme.color.primary};
  font-size: ${rem(12)};
  width: ${rem(650)};
  box-shadow: 0 0 10px 2px ${({ theme }) => theme.separatorColor};
  margin-bottom: ${rem(12)};
  background: white;
  padding-bottom: ${rem(12)};
`;

const Header = styled.div`
  padding: ${rem(12)} ${rem(12)} ${rem(4)} ${rem(12)};
  display: flex;
  justify-content: space-between;
`;

const ImageWrapper = styled.div``;

const StyledImg = styled(Img)`
  height: ${rem(52)};
  border-radius: 50%;
`;

const Name = styled.div`
  font-size: ${rem(18)};
  font-weight: bold;
`;

const Role = styled.div`
  font-size: ${rem(14)};
  color: #8e8e8e;
  font-weight: bold;
`;

const DateTime = styled(Role)``;
const PartWrapper = styled.div`
  display: flex;
`;
const NameRoleWrapper = styled.div`
  margin-left: ${rem(12)};
`;

const MessageContentWrapper = styled.div`
  width: 100%;
  margin: ${rem(12)};
  margin-bottom: ${rem(0)};
`;
const AttachmentsWrapper = styled.div`
  width: 100%;
  margin-bottom: ${rem(12)};
`;

const TextWrapper = styled.div`
  text-align: justify;
  width: 95%;
  font-size: 14px;
  // margin-left: ${rem(64)};
  // color: #737373;
  width: ${rem(408)};
`;

const ChangePhotoButton = styled(Dropzone)`
  width: 100%;
  height: ${rem(50)};
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer
  font-size: ${rem(14)};
  color: #8e8e8e;
  font-weight: bold;
  :hover {
    text-decoration: underline;
   
  }
`;

const ButtonWrapper = styled.div`
  display: flex;
  padding: ${rem(0)} ${rem(8)} ${rem(8)} ${rem(8)};
  justify-content: flex-end;
`;

const FilesWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(${rem(180)}, ${rem(190)}));
  grid-gap: 0rem;
  padding: ${rem(10)};
`;
class CommentItem extends Component {
  state = {
    text: '',
    attachments: [],
  };

  onAddAttachments(accepted) {
    const { attachments } = this.state;
    const { saveEveryChange, onMessageSave } = this.props;

    const files = accepted;

    this.setState({ attachments: attachments.concat(files) });

    if (saveEveryChange) {
      onMessageSave({
        files: attachments.concat(files),
      });
    }
  }

  showPreview(url) {
    window.open(url);
  }

  renderMessage() {
    const { isNew, data, saveEveryChange, onMessageSave } = this.props;
    const { text } = this.state;

    if (isNew) {
      return (
        <React.Fragment>
          <StyledTextarea
            placeholder={__('Zadajte text ')}
            onChange={e => {
              this.setState({
                text: e.target.value,
              });
              if (saveEveryChange) {
                onMessageSave({
                  description: e.target.value,
                });
              }
            }}
            value={text}
          />
        </React.Fragment>
      );
    }

    return (
      <React.Fragment>
        <TextWrapper>{data.text}</TextWrapper>
      </React.Fragment>
    );
  }

  renderAttachments() {
    const { isNew } = this.props;
    const { attachments } = this.state;
    const { attachments: propsAttachments } = this.props;

    if (isNew) {
      return (
        <React.Fragment>
          <ChangePhotoButton
            onDrop={(accepted, rejected) =>
              this.onAddAttachments(accepted, rejected)
            }
          >
            {`${__('Pre nahratie súborov kliknite alebo použite')} drag&drop`}
          </ChangePhotoButton>
          {attachments.length ? (
            <FilesWrapper>
              {attachments.map(a => (
                // <FileRow onClick={() => this.showPreview(a.preview)}>
                //   {a.name}
                // </FileRow>
                <FileViewDownload
                  name={a.name}
                  fullPath={a.fullPath}
                  type={a.mimeType}
                  history={this.props.history}
                  customWidth={180}
                  downloadFunction={async () => {
                    return this.props.downloadFunction(a.fullPath);
                  }}
                  error={error => {
                    this.setState({ error });
                  }}
                />
              ))}
            </FilesWrapper>
          ) : (
            <div />
          )}
        </React.Fragment>
      );
    }

    return (
      <React.Fragment>
        {propsAttachments.length ? (
          <FilesWrapper>
            {propsAttachments.map(a => (
              <FileViewDownload
                name={a.name}
                history={this.props.history}
                customWidth={180}
                fullPath={a.fullPath}
                type={a.mimeType}
                downloadFunction={async () => {
                  return this.props.downloadFunction(a.fullPath);
                }}
                error={error => {
                  this.setState({ error });
                }}
              />
            ))}
          </FilesWrapper>
        ) : (
          <div />
        )}
      </React.Fragment>
    );
  }

  render() {
    const { isNew, data, onMessageSave, showSaveButton } = this.props;
    const { attachments, text, saveLoading } = this.state;

    return (
      <Wrapper>
        <Header>
          <PartWrapper>
            <ImageWrapper>
              <StyledImg src={[data.img, '/images/icons/avatar.svg']} />
            </ImageWrapper>
            <NameRoleWrapper>
              <Name>{data.name}</Name>
              <Role>{data.role}</Role>
            </NameRoleWrapper>
          </PartWrapper>
          <PartWrapper>
            {!isNew && (
              <DateTime>
                {formatDate(data.datetime, FORMAT_HUMANE_DATETIME)}
              </DateTime>
            )}
          </PartWrapper>
        </Header>
        <MessageContentWrapper>{this.renderMessage()}</MessageContentWrapper>
        <AttachmentsWrapper>{this.renderAttachments()}</AttachmentsWrapper>
        {isNew && showSaveButton && (
          <ButtonWrapper>
            <Button
              primary
              small
              loading={saveLoading}
              onClick={async () => {
                this.setState({
                  saveLoading: true,
                });
                await onMessageSave({ files: attachments, description: text });
                this.setState({
                  text: '',
                  attachments: [],
                  saveLoading: false,
                });
              }}
            >
              {__('Pridať')}
            </Button>
          </ButtonWrapper>
        )}
      </Wrapper>
    );
  }
}

CommentItem.propTypes = {
  isNew: PropTypes.bool,
  data: PropTypes.shape({}),
  attachments: PropTypes.arrayOf({}),
  onMessageSave: PropTypes.func,
  saveEveryChange: PropTypes.bool,
  showSaveButton: PropTypes.bool,
  downloadFunction: PropTypes.func,
};

CommentItem.defaultProps = {
  isNew: true,
  data: {},
  attachments: [],
  onMessageSave: () => {},
  saveEveryChange: false,
  showSaveButton: true,
  downloadFunction: () => {},
};

export default CommentItem;



// WEBPACK FOOTER //
// ./src/Components/CommentItem/index.jsx